import classNames from 'classnames';
import React from 'react';

import { Heading, Link, Text } from '@sravni/react-design-system/lib/Typography';
import { useIsMobile } from '@sravni/react-utils';

import { ORGANIZATION_TYPE_TO_HEADER_MAP } from '../../constants/organizationType';
import { useOrganizationType } from '../../hooks/organizationType';
import { useMetadataByPath } from '../../hooks/useMetadataByPath';
import commonStyles from '../../styles/common.module.scss';
import { Filters } from '../Filters';

import styles from './about-block.module.scss';

export const AboutBlock = React.memo(() => {
  const organizationType = useOrganizationType();
  const metadata = useMetadataByPath();
  const isMobile = useIsMobile();

  return (
    <div className={classNames(styles.aboutBlock, commonStyles.whiteRoundedBlock, 'h-mb-24')}>
      <Heading level={isMobile ? 3 : 2}>
        {metadata?.heading ?? `Рейтинг ${ORGANIZATION_TYPE_TO_HEADER_MAP[organizationType]}`}
      </Heading>
      <Text size={isMobile ? 12 : 16} className={styles.lead}>
        Рейтинг Сравни рассчитывается на&nbsp;основе количества и&nbsp;качества отзывов, а&nbsp;также числа успешно
        решенных проблем пользователей.{' '}
        <Link href={'/novost/2022/8/08/kak-schitaetsya-rejting-sravni/'} target={'_blank'}>
          Подробнее о&nbsp;методике расчёта
        </Link>
      </Text>
      <Filters />
    </div>
  );
});
